const isSubscription = (offer) => {
  return offer.isSubscription
}

export default isSubscription
